/**
 * 참가비 · 입금 계좌.
 *
 * 대회마다 달라지지 않는 값이라 서버가 내려주지 않는다 — **여기가 단일 출처다.**
 * 안내 화면 · 신청 폼 · 신청 완료가 같은 값을 쓰므로 금액과 계좌번호를
 * 화면마다 다시 적지 않는다.
 */
interface EntryFee {
  target: string
  amountText: string
}

/** 생활체육 챔피언전 참가비 — 일반 참가비와 따로 받고 우승 시상이 붙는다 */
interface ChampionshipFee {
  target: string
  amountText: string
  awardText: string
}

interface DepositAccount {
  sportsText: string
  bankName: string
  accountNo: string
  holderName: string
}

const ENTRY_FEES: EntryFee[] = [
  { target: "가맹도장", amountText: "50,000원" },
  { target: "비가맹도장 및 무소속", amountText: "80,000원" },
]

const CHAMPIONSHIP_FEES: ChampionshipFee[] = [
  {
    target: "생활체육 챔피언전 토너먼트",
    amountText: "100,000원",
    awardText: "우승자 벨트 증정",
  },
  {
    target: "생활체육 챔피언전 원매치",
    amountText: "200,000원",
    awardText: "우승자 벨트 증정",
  },
]

/** 닭싸움 대회 참가비 — 가맹 여부와 상관없이 한 금액이다 */
const CHICKEN_FIGHT_FEES: EntryFee[] = [
  { target: "닭싸움 대회", amountText: "30,000원" },
]

const DEPOSIT_ACCOUNTS: DepositAccount[] = [
  {
    sportsText: "복싱 종목",
    bankName: "신한은행",
    accountNo: "100-038-732353",
    holderName: "사단법인 대한복싱연맹",
  },
  {
    sportsText: "MMA · 무에타이 · 킥복싱 · 주짓수 종목",
    bankName: "신한은행",
    accountNo: "100-033-232814",
    holderName: "사단법인 대한이종격투기연맹",
  },
  {
    sportsText: "닭싸움 종목",
    bankName: "신한은행",
    accountNo: "100-038-871342",
    holderName: "사단법인 국제닭싸움연맹",
  },
]

/** 계좌가 종목별로 갈리므로 오입금을 막는 문구를 값과 함께 둔다 */
const DEPOSIT_NOTICE = "참가하시는 종목에 맞는 계좌로 입금해 주시기 바랍니다."

export {
  CHAMPIONSHIP_FEES,
  CHICKEN_FIGHT_FEES,
  DEPOSIT_ACCOUNTS,
  DEPOSIT_NOTICE,
  ENTRY_FEES,
}
export type { ChampionshipFee, DepositAccount, EntryFee }
